import {BaseContainerModel} from "../../../base-container.model";
import {bl_alg_cc_project_virtual_contact_RowClass} from "../../../../dbschema/bl_alg_cc_project_virtual_contact_link.model";

export class ProjectVirtualContactContainerModel extends BaseContainerModel {
  bl_alg_cc_project_virtual_contact_link: bl_alg_cc_project_virtual_contact_RowClass = new bl_alg_cc_project_virtual_contact_RowClass();
}
